/**
 * Campaign Onboarding - Date formatting and UI helpers
 */
(function (global) {
  "use strict";

  function getButtonIcon(stepId) {
    var icons = {
      "create-demo": "play",
      initiate: "download-alt",
      "start-sync": "transfer",
      "check-payload": "refresh",
      "create-campaign": "plus",
      "import-accounts": "import",
      "import-transactions": "import",
      "complete-onboarding": "ok",
      "confirm-sync": "transfer",
      "fetch-confirm-payload": "download-alt",
    };
    return icons[stepId] || "ok";
  }

  function getStatusLabelClass(status) {
    switch (status.toLowerCase()) {
      case "created":
        return "default";
      case "processing":
        return "info";
      case "completed":
        return "success";
      case "failed":
        return "danger";
      default:
        return "default";
    }
  }

  function formatDate(dateString) {
    if (!dateString) return "-";
    var date = new Date(dateString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  }

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.getButtonIcon = getButtonIcon;
  global.CampaignOnboarding.getStatusLabelClass = getStatusLabelClass;
  global.CampaignOnboarding.formatDate = formatDate;
})(typeof window !== "undefined" ? window : this);
